import $ from 'jquery';

import widgetFactory from '../../widgetFactory';

const widgetName = 'courseElementActions',
  baseClassname = 'js-courseElementActions';

const widget = widgetFactory(widgetName, {
  options: {},

  _create: function () {
    this._super(baseClassname);
    this.data = {
      url: '',
    };

    this._attachEvents();
  },

  _attachEvents: function () {
    var self = this;

    this.element
      .on('mousedown.courseElementActions', '.' + baseClassname + '-copyUrl', function () {
        $(this).blur();
      })
      .on('click.courseElementActions', '.' + baseClassname + '-copyUrl', function (event) {
        //event.preventDefault();
        $(this).blur();
        self.copyUrl(event);
      });
  },

  copyUrl: function (event) {
    this._trigger('onCopyUrl', event, this.data.url);
  },

  setData: function (data) {
    this.data = $.extend(this.data, data);
    this.getWidgetElement('copyUrl').attr('href', this.data.url);
  },
});

export default widget;
